import { render, staticRenderFns } from "./UserMescanMetabolismComparison.vue?vue&type=template&id=1d0b39f6&scoped=true"
import script from "./UserMescanMetabolismComparison.vue?vue&type=script&lang=js"
export * from "./UserMescanMetabolismComparison.vue?vue&type=script&lang=js"
import style0 from "./UserMescanMetabolismComparison.vue?vue&type=style&index=0&id=1d0b39f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0b39f6",
  null
  
)

export default component.exports